import GUI from "lil-gui";
/**
 * gui
 */
export const GolobalGUI = new GUI({width : 400});